/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsFormComponent } from '@app/events/events/events-form/events-form.component';
import { Events } from '@app/events/events/events.model';

@Injectable({
  providedIn: 'root',
})
export class EventsFormService {
  constructor(private modalService: NgbModal) {}

  public open(events: null | Events = null): Promise<any> {
    const modal = this.modalService.open(EventsFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.event = events;
    return modal.result;
  }
}
